import React, { useEffect, useState } from "react";

import _ from "lodash";
import cx from "classnames";
import styles from "./toolbar.module.scss";
import Actions from "src/components/actionbar";
import { AddAssets } from "src/components/asset/add";
import { animated, useTransition } from "@react-spring/web";

interface EmailToolbarProps {
  show: boolean;
  dialog?: boolean
  handleAddAssets: () => void;
  handleTemplates: () => void;
  handleWidgets: () => void;
  isDealRoom: boolean
}

const EmailToolbar: React.FC<EmailToolbarProps> = ({
  show,
  dialog,
  handleAddAssets,
  handleTemplates,
  handleWidgets,
  isDealRoom
}) => {
  const [transitions, api] = useTransition(show, () => ({
    initial: { opacity: 0, top: "0px" },
    from: { opacity: 1, top: "-90px" },
    enter: { opacity: 1, top: "0px" },
    leave: { opacity: 0, top: "-90px" },
    // config: { duration: 500 },
    // delay: 500,
  }));

  useEffect(() => {
    api.start();
  }, [show]);

  return transitions(
    (style, item) =>
      item && (
        <animated.div style={style} className={styles.toolbarContainer}>
          <section className={styles.toolbar}>
            {!isDealRoom && dialog && (
              <Actions.IconButton
                icon="paperflite-add"
                tooltip="attach documents"
                onClick={handleAddAssets}
              />
            )}
            {!isDealRoom && !dialog && (
              <Actions.Button
              className={styles.addAssets}
              icon="paperflite-add"
              title="attach documents"
              onClick={handleAddAssets}
            />
            )}

            {!isDealRoom && <Actions.IconButton
              icon="paperflite-document"
              tooltip="templates"
              onClick={handleTemplates}
            />}

            <Actions.IconButton
              icon="paperflite-categories"
              tooltip="widgets"
              onClick={handleWidgets}
            />
          </section>
        </animated.div>
      ),
  );
};

export default EmailToolbar;
